import React from "react";
import styled from "styled-components";
import { useScript } from "../../hooks/useScript/useScript";
import { Box } from "../Box";

const Feedback = styled(Box)`
  & div {
    position: static !important;
    width: 100% !important;
    height: 290px !important;
  }
`;

const QUALTRICS_SCRIPT =
  // eslint-disable-next-line max-len
  "(function(){var g=function(e,h,f,g){this.get=function(a){for(var a=a+'=',c=document.cookie.split(';'),b=0,e=c.length;b<e;b++){for(var d=c[b];' '==d.charAt(0);)d=d.substring(1,d.length);if(0==d.indexOf(a))return d.substring(a.length,d.length)}return null};this.set=function(a,c){var b='',b=new Date;b.setTime(b.getTime()+6048E5);b='; expires='+b.toGMTString();document.cookie=a+'='+c+b+'; path=/; '};this.check=function(){var a=this.get(f);if(a)a=a.split(':');else if(100!=e)'v'==h&&(e=Math.random()>=e/100?0:100),a=[h,e,0],this.set(f,a.join(':'));else return!0;var c=a[1];if(100==c)return!0;switch(a[0]){case 'v':return!1;case 'r':return c=a[2]%Math.floor(100/c),a[2]++,this.set(f,a.join(':')),!c}return!0};this.go=function(){if(this.check()){var a=document.createElement('script');a.type='text/javascript';a.src=g;document.body&&document.body.appendChild(a)}};this.start=function(){var t=this;'complete'!==document.readyState?window.addEventListener?window.addEventListener('load',function(){t.go()},!1):window.attachEvent&&window.attachEvent('onload',function(){t.go()}):t.go()};};try{(new g(100,'r','QSI_S_ZN_bIYC8C1zMecK97f','https://znbiyc8c1zmeck97f-vector.siteintercept.qualtrics.com/SIE/?Q_ZID=ZN_bIYC8C1zMecK97f')).start()}catch(i){}})();";
export const QUALTRICS_ID = "ZN_bIYC8C1zMecK97f";

export const QualtricsFeedback: React.FC = () => {
  useScript(QUALTRICS_SCRIPT);
  return <Feedback data-testid="feedback" id={QUALTRICS_ID} />;
};
